import { render, staticRenderFns } from "./SmallNews.vue?vue&type=template&id=17a31d34&scoped=true&"
import script from "./SmallNews.vue?vue&type=script&lang=js&"
export * from "./SmallNews.vue?vue&type=script&lang=js&"
import style0 from "./SmallNews.vue?vue&type=style&index=0&id=17a31d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a31d34",
  null
  
)

export default component.exports